(() => {
  'use strict';

  const configScript = document.querySelector('script[data-yugimon-store-logic]');
  if (!configScript || (configScript.dataset.template || '').toLowerCase() !== 'index') return;

  function addHomeHeading() {
    const main = document.querySelector('#MainContent');
    if (!main || main.querySelector('h1')) return;

    const firstSection = main.querySelector('.shopify-section, .section-wrapper, section, [data-section-id]') || main.firstElementChild;
    const firstButton = firstSection?.querySelector('a.button, button.button, [class*="button"]');
    if (!firstSection || !firstButton || !firstButton.parentElement) return;

    const wrapper = document.createElement('div');
    wrapper.className = 'yugimon-home-heading';
    wrapper.dataset.yugimonHomeHeading = 'true';

    const eyebrow = document.createElement('p');
    eyebrow.className = 'yugimon-home-heading__eyebrow';
    eyebrow.textContent = 'PREMIUM TCG · FAIR VERFÜGBAR';

    const heading = document.createElement('h1');
    heading.textContent = 'Pokémon TCG. Fair verfügbar.';

    wrapper.append(eyebrow, heading);
    firstButton.parentElement.insertBefore(wrapper, firstButton);
  }

  function clarifyCornersStatus() {
    const heading = Array.from(document.querySelectorAll('#MainContent h2, #MainContent h3')).find((element) =>
      /yugimon\s+corners/i.test(element.textContent || '')
    );
    if (!heading) return;

    const section = heading.closest('.shopify-section, .section-wrapper, section') || heading.parentElement;
    const paragraph = section?.querySelector('p');
    if (!paragraph || paragraph.dataset.yugimonCornersUpdated === 'true') return;

    paragraph.innerHTML = '<strong>Im Aufbau:</strong> Künftig bringen YUGIMON Corners ausgewählte Trading Cards direkt in lokale Partnergeschäfte – hochwertig präsentiert, fair verfügbar und persönlich erreichbar.';
    paragraph.dataset.yugimonCornersUpdated = 'true';
  }

  function initialize() {
    addHomeHeading();
    clarifyCornersStatus();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
